export default async function scrollToElement(selector, {
    retry = 10, retryDelay = 500,
    behavior = 'smooth',
    ...options
} = {}) {
    while(retry--) {
        const element = document.querySelector(selector);
        
        if (element) {
            element.scrollIntoView({ behavior, ...options });
            return;
        }

        await new Promise(resolve => setTimeout(resolve, retryDelay));
    }
}